import React, { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { useApp } from '@/contexts/AppContext';
import { Input } from '@/components/ui/input';
import { Label } from '@/components/ui/label';
import { toast } from 'sonner';

export default function Login() {
  const { t, login } = useApp();
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try { await login(email, password); navigate('/account'); }
    catch (err) { toast.error(err.response?.data?.detail || 'Login failed'); }
    finally { setLoading(false); }
  };

  return (
    <div className="max-w-md mx-auto px-6 py-24" data-testid="login-page">
      <h1 className="font-display text-4xl">{t('auth.signin')}</h1>
      <form onSubmit={submit} className="mt-12 space-y-8">
        <div>
          <Label className="overline">{t('auth.email')}</Label>
          <Input type="email" required className="mt-2 rounded-none border-0 border-b border-foreground focus-visible:ring-0" value={email} onChange={(e) => setEmail(e.target.value)} data-testid="login-email" />
        </div>
        <div>
          <Label className="overline">{t('auth.password')}</Label>
          <Input type="password" required className="mt-2 rounded-none border-0 border-b border-foreground focus-visible:ring-0" value={password} onChange={(e) => setPassword(e.target.value)} data-testid="login-password" />
        </div>
        <button type="submit" disabled={loading} className="w-full bg-foreground text-background px-8 py-4 overline disabled:opacity-50" data-testid="login-submit">{loading ? '…' : t('auth.signin')}</button>
      </form>
      <p className="mt-8 text-sm font-light">{t('auth.noaccount')} <Link to="/register" className="link-underline text-accent" data-testid="login-to-register">{t('auth.signup')} →</Link></p>
    </div>
  );
}
